import BaseLayout from "components/Layout/BaseLayout";
import { Outlet } from "react-router";

const AuthRoutes: React.FC = () => {
  return (
    <BaseLayout>
      <Outlet />
    </BaseLayout>
  );
};

export default AuthRoutes;
